import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import React from "react";
import { useTourPageContext } from "../../../_client/context";
import { DepartureHeaderActionBar } from "./DepartureHeaderActionBar";
import { DepartureHeaderFilterTags } from "./DepartureHeaderFilterTags";
import { DepartureListAlternateYearsModal } from "./DepartureListAlternateYearsModal";
import styles from "./DepartureHeader.module.scss";

export const DepartureHeader: React.FC = () => {
    const { productPage } = useI18n("productPage");
    const { alternateYears } = useTourPageContext();
    const hasAlternateTourYears = alternateYears && alternateYears.length > 0;

    return (
        <div className={styles.container}>
            <Text.Heading
                order="3"
                tag="h2"
                style={{
                    marginBottom: hasAlternateTourYears
                        ? "var(--g-spacing-xs)"
                        : "var(--g-spacing-md)",
                    textAlign: "center",
                }}
            >
                {productPage.tripBuilder.departures.heading.l()}
            </Text.Heading>
            {hasAlternateTourYears && (
                <Text.Body
                    style={{
                        marginBottom: "var(--g-spacing-md)",
                        textAlign: "center",
                    }}
                >
                    {productPage.tripBuilder.alternateYears.description.l()}
                    <DepartureListAlternateYearsModal />
                </Text.Body>
            )}
            <div className={styles["header-wrapper"]}>
                <DepartureHeaderActionBar />
                <DepartureHeaderFilterTags />
            </div>
        </div>
    );
};
